module.exports = __webpack_public_path__ + "img/menu-Collection.79fc2173.svg";